// @flow

/**
 * Websockets
 */
import constants from './constants';
import { fetch } from './api';
import actionTypes from './actions/actionTypes';

// @TODO hack for RN
const navigator = window.navigator || {};
if (!navigator.userAgent) {
  navigator.userAgent = 'ReactNative';
  window.navigator = navigator;
}
const io = require('socket.io-client/socket.io');

function HuWebSocket() {
  this.store = null;
  this.unreadCountsSocket = null;
}

HuWebSocket.prototype.updateUnread = function updateUnread(key, data) {
  let count = this.store.getState().appState.unread[key];

  switch (data.action) {
    case 'inc':
      count += data.count;
      break;
    case 'dec':
      count -= data.count;
      break;
    case 'set':
      count = data.count;
      break;
    default:
      return;
  }

  this.store.dispatch({
    type: actionTypes.COUNTER_UNREAD_SUCCESS,
    unread: { [key]: Math.max(count, 0) },
  });
};

HuWebSocket.prototype.stopListeningToUnreadCounts = function stopListeningToUnreadCounts() {
  if (this.unreadCountsSocket) {
    this.unreadCountsSocket.disconnect();
  }

  this.unreadCountsSocket = null;
};

HuWebSocket.prototype.startListeningToUnreadCounts = async function startListeningToUnreadCounts() {
  if (this.unreadCountsSocket) return;

  this.unreadCountsSocket = io.connect(constants.WS_URL, {
    path: constants.WS_PATH,
    reconnectionAttempts: 3,
    jsonp: false,
    transports: ['websocket'],
    timeout: 5000,
  });

  this.unreadCountsSocket.on('connect_error', e => console.warn('fail connect', e));
  this.unreadCountsSocket.on('reconnect_failed', e => console.warn('fail reconnect', e));
  this.unreadCountsSocket.on(
    'messages.unread-count',
    data => this.updateUnread('messages', data)
  );
  this.unreadCountsSocket.on(
    'notifications.unread-count',
    data => this.updateUnread('notifications', data)
  );

  const mark = this.unreadCountsSocket;
  try {
    const requests = await Promise.all([
      fetch('messages/unread-count'),
      fetch('notifications/unread'),
    ]);

    if (this.unreadCountsSocket !== mark) {
      return;
    }

    this.store.dispatch({
      type: actionTypes.COUNTER_UNREAD_SUCCESS,
      unread: {
        messages: requests[0].payload.unreadMessages,
        notifications: requests[1].payload.unread,
      },
    });
  } catch (error) {
    this.store.dispatch({ type: actionTypes.COUNTER_UNREAD_FAILURE, error });
  }
};

HuWebSocket.prototype.setStore = function setStore(store: Object): void {
  this.store = store;
};

HuWebSocket.prototype.constructor = HuWebSocket;

export default new HuWebSocket();



// WEBPACK FOOTER //
// ./~/virgo/src/websocket.js